import { INSTAGRAM_SYNC } from '../../../../utils';
import Swal from 'sweetalert2';

/**
 *
 * @param {*} pageId
 */
export const syncInstagramPage = async (pageId) => {
  try {
    await fetch(INSTAGRAM_SYNC, {
      method: 'POST',
      body: JSON.stringify({ pageId })
    });
    Swal.fire({
      icon: 'success',
      title: 'Complete sync with Instagram',
      showConfirmButton: false,
      timer: 3500
    });
  } catch (error) {
    console.error('An error has ocurred', error);
    Swal.fire({
      icon: 'error',
      title: 'Error!',
      text: 'We cannot sync with Instagram'
    });
  }
};
